import React from 'react';
import PropTypes from 'prop-types';
import {Button, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {
  StyledVendorDetailsPanel,
  StyledVendorDetailsPanelContainer,
  StyledVendorDetailsPanelContent,
  StyledVendorDetailsPanelBody,
  StyledVendorDetailsPanelHeader,
  StyledVendorDetailsPanelHeaderText,
} from './StyledVendorDetailsPanel';
import {ChevronRightIcon, TrashIcon} from '../../../../icons';
import EditButton from '../../../EditButton';


const VendorDetailsPanel = ({
  backButtonText = '',
  children,
  contentClassName,
  enableAddPayment = false,
  enabledDelete = false,
  onAddPayment,
  onBack,
  onDelete,
  ...rest
}) => {
  const [t] = useTranslation('main');

  return (
    <StyledVendorDetailsPanel {...rest}>
      <StyledVendorDetailsPanelContainer>
        <StyledVendorDetailsPanelContent className={contentClassName}>
          <StyledVendorDetailsPanelHeader>
            <Space align='center' size='small'>
              <Button
                icon={<ChevronRightIcon />}
                onClick={(e) => onBack && onBack(e)}
                size='small'
                type='text'
              >
                {backButtonText}
              </Button>

              {!backButtonText && (
                <StyledVendorDetailsPanelHeaderText>
                  {t('vendor')} {t('details')}
                </StyledVendorDetailsPanelHeaderText>
              )}
            </Space>

            <Space align='center' size='small'>
              {enabledDelete && (
                <EditButton
                  danger
                  icon={<TrashIcon />}
                  onClick={(e) => onDelete && onDelete(e)}
                  size='middle'
                  tooltipProps={{title: t('delete')}}
                />
              )}

              {enableAddPayment && (
                <Button
                  onClick={onAddPayment}
                  type='primary'
                >
                 + {t('payment')}
                </Button>
              )}
            </Space>

          </StyledVendorDetailsPanelHeader>
          <StyledVendorDetailsPanelBody>
            {children}
          </StyledVendorDetailsPanelBody>
        </StyledVendorDetailsPanelContent>
      </StyledVendorDetailsPanelContainer>
    </StyledVendorDetailsPanel>
  );
}

VendorDetailsPanel.propTypes = {
  backButtonText: PropTypes.string,
  contentClassName: PropTypes.string,
  enableAddPayment: PropTypes.bool,
  enabledDelete: PropTypes.bool,
  onAddPayment: PropTypes.func,
  onBack: PropTypes.func,
  onDelete: PropTypes.func,
}

export default VendorDetailsPanel;
